export default "__VITE_ASSET__D2aSmC7h__"